import script from "./SyncUserEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncUserEmail.vue?vue&type=script&setup=true&lang=js"

import "./SyncUserEmail.vue?vue&type=style&index=0&id=76c909f2&scoped=true&lang=scss"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c909f2"]])

export default __exports__